(function(){
  'use strict';  
  
  var modalArray;

  theme.Modals = (function() {
    function Modal(id, name, options) {

      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closeOffContentClick: true,
        closingClass: 'modal--is-closing',
        bodyOpenClass: 'modal-open',
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing'
      };

      this.id = id;
      this.modal = document.getElementById(id);

      if (!this.modal) {return false;}

      if (this.modal.getAttribute('data-section-locked') == 'false') {
        defaults.bodyOpenClass = "modal-open--unlocked"
      }

      this.modalContent = this.modal.querySelector('.modal__inner');
      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;

      this.isSolid = this.config.solid;
      this.init();
    }

    Modal.prototype.init = function() {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('data-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });

      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });

      document.addEventListener('drawerOpen', function() {
        this.close();
      }.bind(this));
    };

    Modal.prototype.open = function(evt) {
      var externalCall = false;

      if (this.modalIsOpen) return;

      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        this.activeSource = evt.currentTarget.setAttribute('data-expanded', 'true');
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.modal.classList.add(this.config.openClass);
      
      document.documentElement.classList.add(this.config.bodyOpenClass);

      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;

      slate.a11y.trapFocus({
        container: this.modal,
        elementToFocus: this.focusOnOpen,
        namespace: 'modal_focus'
      });

      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));

      if (this.modal.getAttribute('data-bind-events') == 'true') {
      } else {
        this.bindEvents();
      }
    };

    Modal.prototype.close = function(evt) {
      if (!this.modalIsOpen) {
        return;
      }

      if (evt) {
        if (evt.target.closest('.js-modal-close')) {

        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }

      document.activeElement.blur();

      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);

      document.documentElement.classList.remove(this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);

      window.setTimeout(function() {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('data-expanded')) {
          this.activeSource.setAttribute('data-expanded', 'false').focus();
        }
      }.bind(this), 500);

      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = false;

      slate.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });

      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));

      this.unbindEvents();
      
      if (modalArray != null && modalArray.length > 0) {
        initPopupDelay(modalArray[0][0], modalArray[0][1], modalArray[0][2])
        modalArray.splice(0, 1);
      }
    };

    Modal.prototype.bindEvents = function() {
      window.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

      if (this.config.closeOffContentClick) {
        this.modal.on('click.modal', this.close.bind(this));
      }
    };

    Modal.prototype.unbindEvents = function() {
      document.documentElement.off('.modal');

      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };

    return Modal;
  })();
  
  theme.LocatorButton = (function() {
    var selectors = {
      locale: '[data-locale-input]',
      currency: '[data-currency-input]'
    };
    
    function LocatorButton(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.currencySelector = this.container.querySelectorAll(".currency-selector");
      this.localeSelector = this.container.querySelectorAll(".locale-selector");
	  this.form = this.container.querySelector('.localization-form');
      this.testMode = this.container.dataset.testMode
      this.isModal = this.container.classList.contains('modal__centered');
      this.cookieName = 'locator-LocatorPopup';
      
      if (this.isModal) {        
        this.data = {
          secondsBeforeShow: container.getAttribute('data-delay-seconds'),
          daysBeforeReappear: container.getAttribute('data-delay-days'),
          cookie: Cookies.get(this.cookieName)
        };
      }     
      this.init();
    }
  
    LocatorButton.prototype = Object.assign({}, LocatorButton.prototype, {
      init: function() {
        if (this.currencySelector) { 

          this.currencySelector.forEach(selector => {
            this.initSelectors(selector, this.form.querySelector(selectors.currency))
          });
        }

        if (this.localeSelector) {
          this.localeSelector.forEach(selector => {
            this.initSelectors(selector,  this.form.querySelector(selectors.locale))
          });
        }
      },
      
      initSelectors: function(selector, formSelector) {
        if (selector.dataset.type == "icons") {
          selector.addEventListener("click",function(e) {
            if (e.target.parentElement.dataset.value.includes("http") == true) {
              window.location.href = e.target.parentElement.dataset.value + '?locator=true';
            } else {
              formSelector.value = e.target.parentElement.dataset.value;
              if (this.isModal) {
                this.closePopup(true)
              } else {
                this.form.submit();
              }
            }
          }.bind(this));
        } else {
          selector.addEventListener("change", function(e) {
            if (e.target.value.includes("http") == true) {
              window.location.href = e.target.value + '?locator=true';
            } else {
              formSelector.value = e.target.value;
              if (this.isModal) {
                this.closePopup(true)
              } else {
                this.form.submit();
              }
            }
          }.bind(this));
        }
      },
      
      closePopup: function(success) {
        // Remove a cookie in case it was set in test mode
        if (this.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          this.form.submit();
          return;
        }

        if (this.data != null && this.data.cookie != 'opened') {
          var expiry = success ? 200 : this.data.daysBeforeReappear;
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        }

        this.form.submit();
      }
    });
  
    return LocatorButton;
  })();
  
  theme.FooterSection = (function() {
    var selectors = {
      locale: 'FooterLocale',
      currency: 'FooterCurrency'
    };
  
    function Footer(container) {
      this.container = container;
  
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;
  
      this.init();
    }
  
    Footer.prototype = Object.assign({}, Footer.prototype, {
      init: function() {
        this.removePBLUrl(this.container.querySelector("#RemovePBL"))
        
        this.container.querySelectorAll(".image-grid-item--loader").forEach((el) => {
          el.classList.remove('loading', 'loading--delayed');
          el.classList.add('loaded');
        });
        
        var localeEl = document.getElementById(selectors.locale);
        var currencyEl = document.getElementById(selectors.currency);

        this.windowWidth = window.innerWidth;
  
        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }
  
        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
  
        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);


        if (window.matchMedia('screen and (min-width: 590px)').matches) {
          setTimeout(function() { this.initGrid() }.bind(this), 50);
        }

        window.on('orientationchange', theme.Helpers.debounce(300, function() {
            setTimeout(function() {
                if (this.pckry) {
                    this.pckry.layout()
                }               
            }.bind(this), 50);
          /*if(this.pckry){this.pckry.destroy()}
          setTimeout(function() { this.initGrid() }.bind(this), 50);*/
        }.bind(this)), false);
      },

      initGrid: function() {
        var sectionId = this.container.getAttribute('data-section-id')
        var id = '.grid__item--' + sectionId
        
        this.packeryDefaults = {
          itemSelector: id
        }
        
        this.pckry = new Packery(this.container.querySelector(".grid"), this.packeryDefaults);
      },
      
      initDoubleMobileNav: function() {
        var menuPlaceholder = document.getElementById(ids.footerNavWrap);
        if (!menuPlaceholder) {
          return;
        }
  
        var mobileNav = document.getElementById(ids.mobileNav);
        var footerNav = document.getElementById(ids.footerNav);
        var clone = mobileNav.cloneNode(true);
        var navEl = clone.querySelector('.mobile-nav__wrapper')
  
        // Append cloned nav to footer, initialize JS, then show it
        footerNav.appendChild(navEl);
        new theme.MobileNav({
          id: ids.footerNav,
          inHeader: false
        });
  
        menuPlaceholder.classList.remove('hide');
      },
  
      onUnload: function() {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }
  
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      },

      removePBLUrl: function(remover) {
        var paymentIcons = this.container.querySelector(".copyright__content:last-child")
        if (remover && paymentIcons && paymentIcons.innerHTML.includes("Shopify")) {
          paymentIcons.remove()
        }
      }
    });
  
    return Footer;
  })();
  
  theme.Popup = (function() {
    var selectors = {
      locale: 'popupLocale',
      currency: 'popupCurrency'
    };

    function Popup(container) {
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;


      this.sectionId = this.container.id;

      if (this.sectionId == 'LocatorPopup' && window.location.href.includes('?locator=true')) {
        var url= document.location.href;
        window.history.pushState({}, "", url.split("?")[0]);
        return
      }

      if (this.container.dataset.heightactivator) {
        this.activator = parseInt(this.container.dataset.heightactivator)

        window.onscroll = function (e) {  
        // called when the window is scrolled.  
          this.purchaseScrollHandler()
        }.bind(this)
        return
      }
      

      this.init();

      this.cookieName = 'locator-' + this.sectionId;

      if (!container) {
        return;
      }

      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }

      this.data = {
        secondsBeforeShow: container.getAttribute('data-delay-seconds'),
        daysBeforeReappear: container.getAttribute('data-delay-days'),
        cookie: Cookies.get(this.cookieName),
        testMode: container.dataset.testMode
      };

      this.modal = new theme.Modals(this.container.id, this.container.id + '-popup-modal');

      // Open modal if errors or success message exist
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }

      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }

      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));

      if (Shopify && Shopify.designMode) {
        return;
      }

      if (!this.data.cookie || this.data.testMode === 'true') {
        if (modalArray == null) {
          modalArray = []
          initPopupDelay(this.modal, this.container, this.data)
        } else {
          modalArray.push([this.modal, this.container, this.data]);
        }
      }

    }

    Popup.prototype = Object.assign({}, Popup.prototype, {
      init: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }

        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);
      },
      
      closePopup: function(success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }

        var expiry = success ? 200 : this.data.daysBeforeReappear;

        Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
      },

      onLoad: function() {
        this.modal.open();
      },

      onSelect: function() {
        this.modal.open();
      },

      onDeselect: function() {
        this.modal.close();
      },

      onUnload: function() {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      },

      purchaseScrollHandler: function() {
        if (window.scrollY > this.activator) {
          if (this.stickyActive) {
            return;
          }
  
          this.stickyActive = true;
          
          if (document.querySelector("#BackToTop") != null) {
            document.querySelector("#BackToTop").classList.add('btn--back-to-top__padding');
          }
    
          this.container.classList.add("modal--is-active");
        } else {
          if (!this.stickyActive) {
            return;
          }
    
          this.stickyActive = false;
          
          if (document.querySelector("#BackToTop") != null) {
            document.querySelector("#BackToTop").classList.remove('btn--back-to-top__padding');
          }
    
          this.container.classList.remove("modal--is-active");
        }
      }
    });
    return Popup;
  })();
  
  function initPopupDelay(modal, container, data) {
    if (Shopify && Shopify.designMode) {
      return;
    }

    setTimeout(function() {
      var check_eu = container.getAttribute('data-check-eu');

      if (check_eu == 'true') {
        var country1 = 'US';
        var eu_country_codes = ['AL','AD','AM','AT','BY','BE','BA','BG','CH','CY','CZ','DE','DK','EE','ES','FO','FI','FR','GB','GE','GI','GR','HU','HR','IE','IS','IT','LT','LU','LV','MC','MK','MT','NO','NL','PO','PT','RO','RU','SE','SI','SK','SM','TR','UA','VA'];
        fetch('https://ipapi.co/country/')
        .then(function(response) {
          return response.text();
        })
        .then(function(data) {
          if (eu_country_codes.indexOf(data) != -1) {
            modal.open();
          } else {
            return
          }
        }.bind(this));
      } else {
        modal.open();
      }
    }, data.secondsBeforeShow * 1000);
  }

  theme.PasswordHeader = (function() {
    function PasswordHeader() {
      this.init();
    }

    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function() {
        if (!document.querySelector('#LoginModal')) {
          return;
        }

        var passwordModal = new theme.Modals('LoginModal', 'login-modal', {
          focusIdOnOpen: 'password',
          solid: true
        });

        // Open modal if errors exist
        if (document.querySelectorAll('.errors').length) {
          passwordModal.open();
        }
      }
    });

    return PasswordHeader;
  })();
  
  theme.Countdown = (function() {
    let _second = 1000;
    let _minute = _second * 60;
    let _hour = _minute * 60;
    let _day = _hour * 24;

    function Countdown(container) {
      this.container = container;    
      this.sectionId = container.getAttribute('data-section-id');
	  this.slideshow = this.container.querySelector('.countdown_timer');
      this.deadline = this.slideshow.dataset.deadline

      this.container = document.querySelector(".media__text--" + this.sectionId)
      
      this.init();

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', function(event) {
          this.container = document.querySelector(".media__text--" + this.sectionId)
          this.slideshow = this.container.querySelector('.countdown_timer');
          this.deadline = this.slideshow.dataset.deadline

          this.init();
        }.bind(this))
      }
    }

    Countdown.prototype = Object.assign({}, Countdown.prototype, {
      init: function() {
        if (this.deadline.includes("-")) {
          this.deadline = this.deadline.replace("-", "/");
        } else if (this.deadline.includes(".")) {
          this.deadline = this.deadline.replace(".", "/");
        }
        
        if(!this.deadline.includes(" ")) {
          this.deadline = this.deadline + " 00:00:00"
        }
        
        if (this.deadline.includes("24:00")) {
          this.deadline = this.deadline.replace("24:00", "23:59");
        } else if (this.deadline.includes("24:")) {
          this.deadline = this.deadline.replace("24:", "23:");
        }
        
        
        
        if (!this.slideshow) { return }
        
        if(this.deadline.toLowerCase().includes("demo")) {
          var today = new Date();
          var tomorrow = new Date();
          this.deadline = tomorrow.setDate(today.getDate()+3);
        }
          
        if (this.slideshow.dataset.deadline != '') {
          this.timer = setInterval(this.startTimer.bind(this), 1000);
        }
      },

      startTimer: function() {
        var now = new Date();
        var end = new Date(this.deadline);
        var distance = end - now;
        if (distance < 0) {
          clearInterval(this.timer);
          if (this.container.querySelector(".btn--countdown") != null) {
            this.container.querySelector(".btn--countdown").style.display = '';
          }

          return;
        }
        var days = Math.floor(distance / _day);
        var hours = Math.floor((distance % _day) / _hour);
        var minutes = Math.floor((distance % _hour) / _minute);
        var seconds = Math.floor((distance % _minute) / _second);

        this.container.querySelector(".days").innerText = days;
        this.container.querySelector(".hours").innerText = hours;
        this.container.querySelector(".minutes").innerText = minutes;
        this.container.querySelector(".seconds").innerText = seconds;
        this.container.querySelector(".countdown_timer").style.display = '';
      }
    });
    return Countdown;
  })(); 

  theme.Countup = (function() {
    function Countup(container) {
      this.container = container;    
      this.sectionId = container.getAttribute('data-section-id');
      this.container = document.querySelector(".media__text--" + this.sectionId)
	  this.counter = this.container.querySelector(".count-up__container");
      this.target = this.counter.dataset.target
      this.plusCharacter = ""

      this.init();

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', function(event) {
          this.container = document.querySelector(".media__text--" + this.sectionId)
          this.counter = this.container.querySelector(".count-up__container");
          this.target = this.counter.dataset.target
          this.init();
        }.bind(this))
      }
    }

    Countup.prototype = Object.assign({}, Countup.prototype, {
      init: function() {
        if(!this.target.includes(" ")) {
          this.target = this.target.replace(" ", "");
        }
        
        if (this.target.includes("+")) {
          this.target = this.target.replace("+", "");
          this.plusCharacter = "+"
        }
  
        if(this.target.toLowerCase().includes("demo")) {
          this.target = "1000"
        }
          
        this.observer = new IntersectionObserver(function(entries) {
          if(entries[0].isIntersecting === true) {
            this.startCounter(this.target)
            this.observer.unobserve(this.counter)
          }
                  
        }.bind(this), { threshold: [0] });
      
        this.observer.observe(this.counter);

        
      },

      startCounter: function(targetNumber) {
        const counters = document.querySelectorAll('.counter ')
        this.counter.innerText = '0' //set default counter value
        this.counter.dataset.count = 0;
        const updateCounter = () => {
          var target = +targetNumber //define increase couter to it's data-target
          const count = +this.counter.dataset.count //define increase couter on innerText
    
          var speed = 200
          target = parseInt(target)
          if (0 <= target && target <= 1000) {
            speed = 750
          } else if (1001 <= target && target <= 5000) {
            speed = 250
          } else if (5001 <= target && target <= 10000) {
            speed = 350
          } else if(10001 < target && target <= 50000) {
            speed= 250
          } else if(50001 < target && target <= 100000) {
            speed= 400
          } else {
            speed = 400
          }
          
          const increment = target / speed // define increment as counter increase value / speed
    
          if (count < target) {
            const newCount = Math.ceil(count + increment);
            this.counter.dataset.count = newCount;
            this.counter.innerText = this._numberWithCommas(newCount);
            setTimeout(updateCounter, 1);
          } else {
            this.counter.innerText = this._numberWithCommas(target); //if default value is bigger that date-target, show data-target
          }
        }
    
        updateCounter()
      },

      updateCounter: function() {
        var target = +this.counter.dataset.target//.getAttribute('data-target') //define increase couter to it's data-target
        const count = +this.counter.dataset.count //define increase couter on innerText
  
        var speed = 200
        target = parseInt(target)
        if (0 <= target && target <= 1000) {
          speed = 1050
        } else if (1001 <= target && target <= 5000) {
          speed = 250
        } else if (5001 <= target && target <= 10000) {
          speed = 350
        } else if(10001 < target && target <= 50000) {
          speed= 250
        } else if(50001 < target && target <= 100000) {
          speed= 400
        } else {
          speed = 400
        }
        
        const increment = target / speed // define increment as counter increase value / speed
  
        if (count < target) {
          const newCount = Math.ceil(count + increment);
          this.counter.dataset.count = newCount;
          this.counter.innerText = this._numberWithCommas(newCount);
          setTimeout(this.updateCounter, 1);
        } else {
          this.counter.innerText = this._numberWithCommas(target); //if default value is bigger that date-target, show data-target
        }
      },

      _numberWithCommas: function(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    });
    return Countup;
  })(); 

  theme.Sales = (function() {
    var selectors = {
      products: [],
      locations: [],
      customers: []
    };
    
    function Sales(container) {
      this.container = container;    
      this.sectionId = this.container.getAttribute('data-section-id');
      this.testMode = this.container.getAttribute('data-test-mode');

      selectors.products = this.container.getAttribute('data-products').split(",");
      selectors.customers= this.container.getAttribute('data-customers').split(",");
      selectors.locations = this.container.getAttribute('data-locations').split(",");

      this.title = this.container.getAttribute('data-title')
      
      this.offset = this.container.getAttribute('data-offset');
      this.delay = this.container.getAttribute('data-delay');

      if (this.title == "") {
        return
      }
      
      if (Shopify && Shopify.designMode && this.testMode == "true") {
        this.container.classList.add('modal--is-active')
        return;
      }

      this.salesTimer = setInterval(this.startTimer.bind(this), this.offset);

      this.container.querySelector(".js-modal-close").addEventListener("click", function() {
        this.offset = parseInt(this.offset) + 20000
        clearInterval(this.salesTimer);
        this.salesTimer = setInterval(this.startTimer.bind(this), this.offset);
        this.container.classList.remove('modal--is-active')
      }.bind(this))
    }

    Sales.prototype = Object.assign({}, Sales.prototype, {
      init: function(pID) {
        fetch(`/products/${pID}.json`)
        .then(response => response.json())
        .then(function(data) {
          if (data.status === 422) {
            this.error(data);
          } else {
            this.openPopup(data.product)
          }
        }.bind(this));
      },

      startTimer: function() {
        //setTimeout(function() {
          if (!this.container.classList.contains("modal--is-active") && selectors.customers.length > 0 && selectors.locations.length > 0) {
            this.init(selectors.products[this.getRandom(selectors.products.length)])
          }                              
        //}.bind(this), this.getRandom(this.offset/2));
        
      },

      openPopup: function(product) {
        let notificationItemImg = this.container.querySelector(".cart__image")
        
        let notificationItemTitle = this.container.querySelector(".cart__item-product")
        //let notificationItemLocation = this.container.querySelector(".cart__item-location")
        //let notificationItemCustomer = this.container.querySelector(".cart__item-customer")
        let notificationItemTimeAgo = this.container.querySelector(".cart__item-time")

        var selectedCustomer = ""
        var selectedLocation = ""
        var selectedProduct = ""
            
        selectedProduct = product.title
        notificationItemTitle.setAttribute('href', "/products/" + product.handle)
        this.container.querySelector(".cart__item-title").setAttribute('href', "/products/" + product.handle)

        if(notificationItemImg.querySelector("span")) {
          notificationItemImg.querySelector("span").remove()
        }
        
        if(notificationItemImg.querySelector("a")) {
          notificationItemImg.querySelector("a").setAttribute("href", "/products/" + product.handle)
        }
          
        if(notificationItemImg.querySelector("img") && product && product.image) {
          notificationItemImg.querySelector("img").setAttribute('src', product.image.src)
        } 
      
        selectedCustomer = selectors.customers[this.getRandom(selectors.customers.length)]  

        selectedLocation = selectors.locations[this.getRandom(selectors.locations.length)]       

        if (notificationItemTitle) {
          notificationItemTitle.innerHTML = this.title.replace('[customer]', selectedCustomer).replace('[location]', selectedLocation).replace('[product]', "<b>" + selectedProduct + "</b>").replace('[ customer ]', selectedCustomer).replace('[ location ]', selectedLocation).replace('[ product ]', "<b>" + selectedProduct + "</b>")
        }
        


        
        if(notificationItemTimeAgo){
          var timeAgo = this.getRandom(20)
          timeAgo = timeAgo == 0 ? 1 : timeAgo

          if (timeAgo == 1) {
            notificationItemTimeAgo.innerHTML = theme.strings.oneMinuteAgo.replace('[count]', timeAgo)
          } else {
            notificationItemTimeAgo.innerHTML = theme.strings.otherMinuteAgo.replace('[count]', timeAgo)
          }
          //notificationItemTimeAgo.innerHTML = timeAgo == 0 ? "just now." : `${timeAgo} minute${timeAgo == 1 ? '' : 's'} ago.`
        }
        if(this.container.classList.add) {
          this.container.classList.add('modal--is-active')
          setTimeout(function () {this.container.classList.remove('modal--is-active')}.bind(this), this.delay);
        }         
      },

      getRandom: function(max){ 
        return Math.floor(Math.random() * max) 
      }
    });
    return Sales;
  })();

  theme.Fortune = (function() {

    function Fortune(container) {
      this.container = container;    
      this.sectionId = this.container.getAttribute('data-section-id');
      this.testMode = this.container.getAttribute('data-test-mode');

      this.titleArray = this.container.dataset.array.split("\\n")
      
      this.colorArray = ("#f82,#0bf").split(",")
      
      this.init()
      this.data = {
        secondsBeforeShow: container.getAttribute('data-delay-seconds'),
        daysBeforeReappear: container.getAttribute('data-delay-days'),
        testMode: container.dataset.testMode
      };
      

      this.modal = new theme.Modals(this.container.id, this.sectionId + '-popup-modal');

      // Open modal if errors or success message exist
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }

      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }

      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));

      if (Shopify && Shopify.designMode) {
        return;
      }

      if (this.data.testMode === 'true') {     
        if (modalArray == null) {
          modalArray = []
          initPopupDelay(this.modal, this.container, this.data)
        } else {
          modalArray.push([this.modal, this.container, this.data]);
        }
      }
    }

    Fortune.prototype = Object.assign({}, Fortune.prototype, {
      init: function() {
        const discountArray = this.container.dataset.codes.split("\\n")
        this.container.dataset.codes = ""

        var sectors = [];

        var colorA = getComputedStyle(this.container.querySelector(".color-code--btn")).getPropertyValue('--color-button')
        var colorB = getComputedStyle(this.container.querySelector(".color-code--outlined")).getPropertyValue('--color-secondary-button-text')
        let componentToHex = (val) => {
        const a = Number(val).toString(16);
          return a.length === 1 ? "0" + a : a;
        }
        let rgbtohex = (rgb) => {
          return '#' + rgb
            .match(/\d+/g)
            .map(componentToHex)
            .join('');
        }

        colorA = colorA != null ? rgbtohex(colorA) : '#FFF'
        colorB = colorB != null ? rgbtohex(colorB) : '#000'
      
        for (let i = 0; i < this.titleArray.length; i++) {
          var colorCode;
          if(i & 1) {
            colorCode = colorA
          } else {
            colorCode = colorB
          }
          sectors.push({color: colorCode, label: this.titleArray[i]})
        }
        
        const rand = (m, M) => Math.random() * (M - m) + m;
        const tot = sectors.length;
        const EL_spin = document.querySelector("#spin");
        const ctx = document.querySelector("#wheel").getContext('2d');
        const dia = ctx.canvas.width;
        const rad = dia / 2;
        const PI = Math.PI;
        const TAU = 2 * PI;
        const arc = TAU / sectors.length;
        
        const friction = 0.991; // 0.995=soft, 0.99=mid, 0.98=hard
        let angVel = 0; // Angular velocity
        let ang = 0; // Angle in radians
        var isSpinning = false
        
        const getIndex = () => Math.floor(tot - ang / TAU * tot) % tot;
        
        function drawSector(sector, i) {
          const ang = arc * i;
          ctx.save();
          // COLOR
          ctx.beginPath();
          ctx.fillStyle = sector.color;
          ctx.moveTo(rad, rad);
          ctx.arc(rad, rad, rad, ang, ang + arc);
          ctx.lineTo(rad, rad);
          ctx.fill();
          // TEXT
          ctx.translate(rad, rad);
          ctx.rotate(ang + arc / 2);
          ctx.textAlign = "right";
          ctx.fillStyle = "#fff";
          ctx.font = "bold 16px sans-serif";
          ctx.fillText(sector.label, rad - 10, 10);
          //
          ctx.restore();
        };
        
        function rotate() {
          const sector = sectors[getIndex()];
          ctx.canvas.style.transform = `rotate(${ang - PI / 2}rad)`;
          EL_spin.textContent = !angVel && !isSpinning ? "SPIN" : sector.label;
          EL_spin.style.background = sector.color;
        }
        
        function finishedSpinning() { // Called when the wheel stops spinning
          const sector = sectors[getIndex()];

          var selectedCodes = discountArray[getIndex()].replace(/\s/g, "")

          if (selectedCodes == "-") {
            alert("No luck today");
          } else {
            selectedCodes = selectedCodes.split(",")
            var selectedCode = selectedCodes[Math.floor(Math.random()*selectedCodes.length)];
            alert(selectedCode);
          }
          
        }
        
        function frame() {
          if (!angVel) return;
          isSpinning = angVel > 0; // Check if the wheel is currently spinning
          angVel *= friction; // Decrement velocity by friction
          if (angVel < 0.002) angVel = 0; // Bring to stop
          ang += angVel; // Update angle
          ang %= TAU; // Normalize angle
          rotate();
          
          if (isSpinning && angVel === 0) { // If the wheel was spinning, but isn't anymore, it has just stopped
            finishedSpinning();
          }
        }
        
        function engine() {
          frame();
          requestAnimationFrame(engine)
        }
        
        // INIT
        sectors.forEach(drawSector);
        rotate(); // Initial rotation
        engine(); // Start engine
        EL_spin.addEventListener("click", () => {
          if (!angVel && !isSpinning) angVel = rand(0.25, 0.35);
        });
      },
      
      closePopup: function(success) {
        // Remove a cookie in case it was set in test mode
        if (this.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }

        if (this.data != null && this.data.cookie != 'opened') {
          var expiry = success ? 200 : this.data.daysBeforeReappear;
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        }
      }
    });
    return Fortune;
  })();

  function DOMProductready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  DOMProductready(function(){
    theme.sections.register('password-header', theme.PasswordHeader);
    theme.sections.register('popup', theme.Popup); 
    theme.sections.register('footer-section', theme.FooterSection); 
    theme.sections.register('locator-button', theme.LocatorButton); 
    theme.sections.register('countdown', theme.Countdown);
    theme.sections.register('countup', theme.Countup);
    theme.sections.register('sales', theme.Sales);
    theme.sections.register('fortune', theme.Fortune);
  });
})();
